<div class="loader-container" *ngIf="loader">
  <div class="loader text-center">
    <mat-spinner></mat-spinner>
  </div>
</div>
